// ShopCard.js
import React from "react";
import { ShopTrans } from "../utils/translations";
import { useAppContext } from "../context/AppContext";
import { trackPixelEvent } from "../utils/pixel";

const ShopCard = ({ item }) => {
  const { language } = useAppContext();
  return (
    <div className="flex flex-col items-center p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
      <img src={item.image} alt={item.name} className="w-full aspect-square object-cover rounded-md"
 />
      <h2 className="mt-4 text-base lg:text-xl font-semibold">{item.name}</h2>
      <p className="text-gray-700 text-sm lg:text-base">{item.price}</p>
      <a target="_blank" onClick={() => trackPixelEvent("BuyItemWhatsApp")} href={language === "russian" ? `https://wa.me/972559116975?text=Привет!%20Хочу%20заказать%20йога%20ништяк%20"${item.name}"%20:)` : `https://wa.me/972559116975?text=Hi!%20I%20want%20to%20order%20${item.name}%20:)`} className="font-semibold bg-pink-500 transition-colors bg-pink rounded-3xl text-white text-sm lg:text-md py-1 px-7 hover:bg-brown w-fit mt-2">
        {ShopTrans[language].buy}
      </a>
    </div>
  );
};

export default ShopCard;
